import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=96b79ec4&scoped=true&lang=pug&"
import script from "./patient.vue?vue&type=script&lang=ts&"
export * from "./patient.vue?vue&type=script&lang=ts&"
import style0 from "./patient.vue?vue&type=style&index=0&id=96b79ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b79ec4",
  null
  
)

export default component.exports